import { Box } from "@mantine/core";
import { FeedbackChart } from "../../../components/charts/FeedbackChart";

const FeedbackInsightsPage = () => {
    return (
        <Box style={{ flex: 1, display: "flex", flexDirection: "column" }}>
            <FeedbackChart
                title="FEEDBACK SENTIMENT"
                height={400}
                showLegend
                showStats
                defaultDaysBack={7}
                colors={{
                    positive: "#37b24d",
                    negative: "#f03e3e"
                }}
            />
        </Box>
    );
};

export default FeedbackInsightsPage;
